// src/utils/helpers.js - Complete helper functions
export const getPerformanceLevel = (score) => {
  if (score >= 85) return { label: 'Excellent', classes: 'bg-green-500 text-white' };
  if (score >= 70) return { label: 'Good', classes: 'bg-blue-500 text-white' };
  if (score >= 55) return { label: 'Developing', classes: 'bg-yellow-500 text-white' };
  if (score >= 40) return { label: 'Needs Work', classes: 'bg-orange-500 text-white' };
  return { label: 'Struggling', classes: 'bg-red-500 text-white' };
};

export const formatDuration = (minutes) => {
  if (minutes < 60) return `${Math.round(minutes)}min`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.round(minutes % 60);
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}min` : `${hours}h`;
};

export const formatTime = (seconds) => {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
};